import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import type { Announcement } from '@/types'

interface AnnouncementsResponse {
  data: Announcement[]
}

export function useAnnouncements() {
  return useQuery({
    queryKey: ['customer', 'announcements'],
    queryFn: async () => {
      const response = await api.get<AnnouncementsResponse>('/api/customer/announcements')
      return response.data.data
    },
  })
}
